function titleFullSizeChecker() {
	const cardFull = document.querySelectorAll('.js-academy-video-card.full');

	cardFull.forEach(function (card) {
		const titles = card.querySelectorAll('.js-academy-video-title-full');
		titles.forEach(function (title) {
			if (title.textContent.length > 65) {
				title.classList.add('text--xxl');
			}
		});
	});
}

function titleSizeChecker() {
	const titles = document.querySelectorAll('.js-academy-video-title');

	titles.forEach(function (title) {
		if (title.textContent.length > 65) {
			title.classList.add('text--xxl');
		} else if (title.textContent.length > 75) {
			title.classList.add('text--xl');
		}
	});
}

function modalTitleSizeChecker() {
	const titlesModal = document.querySelectorAll('.js-video-modal-title');
	titlesModal.forEach(function (title) {
		if (title.textContent.length > 65) {
			title.classList.add('text--xxl');
		}
	});
}

export { titleSizeChecker, modalTitleSizeChecker, titleFullSizeChecker };
